export const APP_TYPE = {
  WX: 1,
  DD: 2,
}
